<script>
export default {
  name: "index",
  data() {
    return {
    code:'',
    }
  },
  mounted() {
   this.code= Date.parse(new Date()) + parseInt(this.$route.params.code)*2 + 112
  }
}
</script>

<template>
<div>{{code}}</div>
</template>

<style scoped lang="scss">

</style>
